import { useState, useEffect } from 'react'
import { useParams } from 'react-router'

import {
  useShippingDetail,
  useFullTracking,
  useShippingStates,
} from '../services/shippingsTracking'
import { useUserContext } from '../auth/UserProvider'

import TrackingStatus from '../ui/modules/trackingStatus'
import Loader from '../ui/views/Loader'
import DrawerWrapper from '../ui/modules/DrawerWrapper'
import ShippingDetailUI from '../ui/views/ShippingDetail'
import useTrackingLine from './useTrackingLine'
import { SHIPPING_STATUS_CODES } from '../common/constants'
import ScheduledPickupDrawer from '../ui/modules/ScheduledPickupDrawer'

const ShippingDetail = () => {
  const { id: shippingId } = useParams()
  const {
    isLoading: isLoadingUserData,
    statusList,
    auditData,
  } = useUserContext()

  const {
    data: shippingDetail,
    isLoading: isLoadingShippingDetail,
    refetch,
  } = useShippingDetail(shippingId, statusList, {
    enabled: Boolean(statusList?.length),
  })

  const { data: shippingsState, isLoading: isLoadingShippingsState } =
    useShippingStates([shippingId])

  const [isTrackingDrawerOpen, setIsTrackingDrawerOpen] = useState(false)
  const {
    data: fullTrackingData,
    isLoading: isLoadingFullTracking,
    isSuccess: isFullTrackingDataAvailable,
  } = useFullTracking(shippingDetail?.info.shippingCode)

  const [incidentBeingSolved, setIncidentBeingSolved] = useState(null)
  const isIncidentDrawerOpen = Boolean(incidentBeingSolved)
  const handleCloseIncidentWidget = () => {
    refetch()
    setIncidentBeingSolved(null)
  }

  const {
    getTrackingData,
    activateReturnShippingInfo,
    cancelActivateReturn,
    scheduledPickupShippingsInfo,
    cancelScheduledPickup,
  } = useTrackingLine(statusList, setIncidentBeingSolved, fullTrackingData)
  const blah = address => {
    console.log(address)
  }

  useEffect(() => {
    document.addEventListener(
      'incident-solver:general:close',
      handleCloseIncidentWidget,
    )

    document.addEventListener('incident-solver:confirm-address', blah)

    return () => {
      document.removeEventListener(
        'incident-solver:general:close',
        handleCloseIncidentWidget,
      )

      document.removeEventListener('incident-solver:confirm-address', blah)
    }
  }, [])

  return (
    <>
      <ShippingDetailUI
        isLoading={
          isLoadingUserData ||
          isLoadingShippingDetail ||
          isLoadingShippingsState
        }
        data={shippingDetail}
        state={shippingsState}
        cancelActivateReturn={cancelActivateReturn}
        activateReturnShippingInfo={activateReturnShippingInfo}
        trackingLineData={getTrackingData(shippingDetail)}
        showFullTrackingButton={isFullTrackingDataAvailable}
        onOpenFullTrackingDrawer={() => setIsTrackingDrawerOpen(true)}
      />
      <DrawerWrapper
        isOpen={isTrackingDrawerOpen}
        onClose={() => setIsTrackingDrawerOpen(false)}
      >
        {isLoadingFullTracking ? (
          <Loader />
        ) : (
          <TrackingStatus
            deliveryDate={shippingDetail?.info?.committedDeliveryDatetime}
            cancellationDatetime={shippingDetail?.info?.cancellationDatetime}
            incidentData={shippingDetail?.info?.incident}
            fullTrackingData={fullTrackingData ?? []}
            shippingInfo={shippingDetail?.info}
            isDelivered={
              shippingDetail?.info?.shippingStatusCode.code ===
              SHIPPING_STATUS_CODES.delivered
            }
            isReturned={
              shippingDetail?.info?.shippingStatusCode.code ===
              SHIPPING_STATUS_CODES.returned
            }
            isCancelled={shippingDetail?.info?.isCancelled}
          />
        )}
      </DrawerWrapper>
      <DrawerWrapper
        isOpen={isIncidentDrawerOpen}
        onClose={handleCloseIncidentWidget}
      >
        <incident-solver
          incident-type-code={incidentBeingSolved?.incidentTypeCode}
          shipping-code={incidentBeingSolved?.shippingCode}
          process-code={auditData.process_code}
          user-code={auditData.user_code}
        />
      </DrawerWrapper>

      <ScheduledPickupDrawer
        shippingsInfo={scheduledPickupShippingsInfo}
        onClickClose={cancelScheduledPickup}
      />
    </>
  )
}

export default ShippingDetail
